import React, { createContext, useEffect, useState } from 'react';
import PostApiCall from '../Components/Helpers/PostAPI';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [allcuisines, setAllCuisines] = useState([]);

  useEffect(() => {
    // PostApiCall.postRequest({}, 'getproductlist').then((res) =>
    //   res.json().then((data) => {
    //     if (data?.message?.length) {
    //       setAllCuisines(data.message);
    //     }
    //   })
    // );
  }, []);

  return (
    <ProductContext.Provider value={{ allcuisines }}>
      {children}
    </ProductContext.Provider>
  );
};
